import { render, staticRenderFns } from "./ProcesosFinalizados.vue?vue&type=template&id=5af0c016&scoped=true"
import script from "./ProcesosFinalizados.vue?vue&type=script&lang=js"
export * from "./ProcesosFinalizados.vue?vue&type=script&lang=js"
import style0 from "./ProcesosFinalizados.vue?vue&type=style&index=0&id=5af0c016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0c016",
  null
  
)

export default component.exports